import React from 'react'
import './style.css'
import { Link } from 'react-router-dom'
import axios from 'axios'
import toast from 'react-hot-toast'

function Bookcards({
  _id,
  title,
  image_url,
  author,
  categories,
  language,
  price,
  book_image,
  cefrLevel
}) {

  let InvalidImage = image_url ? image_url : book_image;
  if (!InvalidImage || InvalidImage === "") {
    InvalidImage = 'https://thecharulathapublications.com/wp-content/uploads/2022/11/book-placeholder.png';
  }

  let shortenedTitle = title;
  let shortendAuthor = author;

  // if (title && title.length > 20) {
  //   shortenedTitle = title.substr(0, 20) + "...";
  // }

  // if (author && author.length > 15) {
  //   shortendAuthor = author.substr(0, 15) + "...";
  // }

  // بررسی ادمین بودن کاربر
  const currentUser = localStorage.getItem('currentUser');
  let isAdmin = false;
  if (currentUser) {
    try {
      const user = JSON.parse(currentUser);
      isAdmin = user.role === 'admin';
    } catch (e) {
      console.error("Error parsing user:", e);
    }
  }

  // تابع حذف کتاب
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this book?')) {
      try {
        await axios.delete(`${process.env.REACT_APP_API_URL}/summary-book/${id}`);
        toast.success('Book deleted successfully!');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } catch (error) {
        console.error("Error deleting book:", error);
        toast.error('Failed to delete book');
      }
    }
  };

  // تعیین رنگ badge بر اساس سطح CEFR
  const getCefrBadgeClass = (level) => {
    if (!level) return 'cefr-a1';
    switch(level.toUpperCase()) {
      case 'A1': return 'cefr-a1';
      case 'A2': return 'cefr-a2';
      case 'B1': return 'cefr-b1';
      case 'B2': return 'cefr-b2';
      case 'C1': return 'cefr-c1';
      case 'C2': return 'cefr-c2';
      default: return 'cefr-a1';
    }
  };

  return (
    <div className="col">
      <div className="card p-1 shadow">
        <div className="d-flex">
          <div className="col-5 d-flex">
            <Link to={`/read-summary/${_id}`}>
              <img className="img-fluid rounded" style={{ height: '180px', objectFit: 'cover', width: '100%' }} src={InvalidImage} alt="" />
            </Link>
          </div>
          <div className="col-7 ps-2">
            <div className="mb-2">
              <h6 className="card-title english-title">{shortenedTitle}</h6>
              <p className="font-size-13 m-0 author-publication english-text">{shortendAuthor}</p>
              
              {categories && categories.length > 0 && (
                <div className="categories-container mt-1">
                  {categories.slice(0, 2).map((cat, idx) => (
                    <span key={idx} className="category-badge">{cat}</span>
                  ))}
                  {categories.length > 2 && <span className="category-badge more">+{categories.length - 2}</span>}
                </div>
              )}
              
              <div className="cefr-badge mt-1">
                <span className={`badge ${getCefrBadgeClass(cefrLevel)}`}>
                  📚 {cefrLevel || 'A1'}
                </span>
              </div>
            </div>
            <div className="d-flex gap-2">
              <Link to={`/read-summary/${_id}`} className="btn lh-1 btn-outline-success">Read Summary</Link>
              {isAdmin && (
                <>
                  <Link to={`/edit-summary-book/${_id}`} className="btn lh-1 btn-outline-warning">Edit</Link>
                  <button className="btn lh-1 btn-outline-danger" onClick={() => handleDelete(_id)}>Delete</button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Bookcards